export enum EMdfOutcomeValueType {
  Financial = 'Financial',
  Number = 'Number',
  Percentage = 'Percentage',
  FreeText = 'Free text',
}

export type TMdfOutcomeItemValue = string | number | null

export interface IMdfOutcomeItem {
  name: string
  valueType: EMdfOutcomeValueType
  value: TMdfOutcomeItemValue
}
